module.exports = __webpack_public_path__ + "img/bg_pattern-35.c2656387.png";